/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-no-bind */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { Button, Col, Grid, Layout as LayoutAnt, Row } from 'antd';
import { Logo } from 'shared/components/logo';
import { Menu } from 'layout/components/menu';
import {
  LeftOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RightOutlined,
} from '@ant-design/icons';

import './style.less';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';
import LogoNew from 'shared/components/logo/LogoNew';

const { Sider } = LayoutAnt;
const { useBreakpoint } = Grid;

export default function SideBar(): ReactElement {
  const { lg, xl } = useBreakpoint();
  const { vivalinkTheme } = useSelector(
    (state: ApplicationState) => state.session,
  );
  const [{ collapsed, collapsedWidth }, setCollapsed] = useState({
    collapsed: false,
    collapsedWidth: 0,
  });

  function handleCollapsed(width: number): VoidFunction {
    return (): void => {
      setCollapsed({
        collapsedWidth: width,
        collapsed: !collapsed,
      });
    };
  }

  const iconTriggerMobile = collapsed ? (
    <MenuUnfoldOutlined />
  ) : (
    <MenuFoldOutlined />
  );

  const iconTriggerDesktop = collapsed ? <RightOutlined /> : <LeftOutlined />;

  const mediaLgXl = lg && xl;

  useEffect(() => {
    setCollapsed({
      collapsedWidth: 0,
      collapsed: !mediaLgXl,
    });
  }, [mediaLgXl]);

  const { settingInfo } = useSelector(
    (state: ApplicationState) => state.settingInfo,
  );
  const [theme, setTheme] = useState<Record<string, any>>({});

  useEffect(() => {
    if (settingInfo != null && settingInfo?.theme != null) {
      setTheme(settingInfo.theme);
    }
  }, [settingInfo]);

  return (
    <Sider
      collapsedWidth={collapsedWidth}
      collapsed={collapsed}
      className="full-height-page side-bar yahuikeji-layout-sideBar"
      trigger={null}
      style={{
        zIndex: mediaLgXl ? 100 : 102,
        backgroundColor: '#fff',
        // backgroundColor: vivalinkTheme === 'dark' ? 'rgb(20,20,20)' : '#fff',
      }}
      ref={(el) =>
        el &&
        el.style.setProperty(
          'background-color',
          theme?.backgroundColor != null ? theme?.backgroundColor : '',
          'important',
        )
      }
    >
      {!mediaLgXl && (
        <Button
          className="header-trigger"
          type="primary"
          onClick={handleCollapsed(0)}
          style={{
            backgroundColor: theme != null ? theme.backgroundColor : '',
          }}
        >
          {iconTriggerMobile}
        </Button>
      )}
      <Row
        style={{ height: '60px', background: 'var(--logoBg)' }}
        justify="center"
      >
        <LogoNew collapsed={collapsed} svg />
      </Row>
      <div
        className="yahuikeji-menu"
        style={{
          backgroundColor: vivalinkTheme === 'dark' ? 'rgb(20,20,20)' : '#fff',
        }}
      >
        <div className="box">
          <Menu />
        </div>
        {mediaLgXl && (
          <div className="footer">
            <Button
              type="text"
              onClick={handleCollapsed(80)}
              className="bottom-trigger"
            >
              {iconTriggerDesktop}
            </Button>
          </div>
        )}
      </div>
    </Sider>
  );
}
